__turbopack_context__.v({
  "contentShow": "Modal-module__6A9Gha__contentShow",
  "is-large": "Modal-module__6A9Gha__is-large",
  "is-transparent": "Modal-module__6A9Gha__is-transparent",
  "lc-icon-button": "Modal-module__6A9Gha__lc-icon-button",
  "lc-modal": "Modal-module__6A9Gha__lc-modal",
  "lc-modal-content": "Modal-module__6A9Gha__lc-modal-content",
  "lc-modal-underlay": "Modal-module__6A9Gha__lc-modal-underlay",
});
